import React, { useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import commonUtils from "../../script/utils/commonUtils";

import resourceRest from "../../rest/resourceRest";

import { Grid } from "../components/Grid";
import { Layout } from "../containers/Layout";
import { Spacer } from "../components/Spacer";
import { FileSelect } from "../components/FileSelect";
import { SettingsItem } from "./settings/SettingsItem";
import { ContentBody } from "../containers/ContentBody";
import { ContentHeader } from "../containers/ContentHeader";

const SettingsStyle = styled.div`
    margin: 0 auto;
    max-width: 1000px;
    min-width: 700px;
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
`;

export const Documents = () => {

    const [uploading, setUploading] = useState(false);

    const onUploadPdf = async (event, documentType) => {
        setUploading(true);
        const file = await commonUtils.readFile(event);
        const { result, name } = file;
        await resourceRest.uploadDocument(name, result, documentType);
        setUploading(false);
    };

    return (
        <Layout>
            <ContentHeader title={intl.get("navigation.documents")} />
            <ContentBody>
                <SettingsStyle>
                    <SettingsItem title={intl.get("navigation.documents") + " " + intl.get("common.upload")} >
                        <Spacer size="medium" variant="horizontal" />
                        <Grid columns="3">
                            <FileSelect
                                multiple
                                accept=".pdf"
                                loading={uploading}
                                onSelect={event => onUploadPdf(event, "news")}
                                value={intl.get("navigation.news") + " " + intl.get("common.upload")} />
                            <FileSelect
                                multiple
                                accept=".pdf"
                                loading={uploading}
                                onSelect={event => onUploadPdf(event, "manual")}
                                value={intl.get("navigation.manual") + " " + intl.get("common.upload")} />
                            <FileSelect
                                multiple
                                accept=".pdf"
                                loading={uploading}
                                onSelect={event => onUploadPdf(event, "agreement")}
                                value={intl.get("navigation.agreement") + " " + intl.get("common.upload")} />
                        </Grid>
                        <Spacer size="medium" variant="horizontal" />
                    </SettingsItem>
                </SettingsStyle>
            </ContentBody>
        </Layout>
    );
};